module.exports = __webpack_public_path__ + "media/10_8.874b5192.wav";